import { useEffect, useState } from 'react'
import { NavLink, Outlet, useLocation } from 'react-router'
import { Sidebar } from './nav/Sidebar'

export function Layout() {
	const [menuOpen, setMenuOpen] = useState(false)
	const location = useLocation()
	// Following a link from the drawer should land on the page, not leave the drawer over it.
	useEffect(() => setMenuOpen(false), [location.pathname, location.search])
	useEffect(() => {
		if (!menuOpen) return
		const onKey = (e: KeyboardEvent) => e.key === 'Escape' && setMenuOpen(false)
		window.addEventListener('keydown', onKey)
		return () => window.removeEventListener('keydown', onKey)
	}, [menuOpen])
	return (
		<div className="shell">
			<header className="mobile-bar">
				<button
					type="button"
					className="menu-button"
					aria-label="Open menu"
					aria-controls="sidebar"
					aria-expanded={menuOpen}
					onClick={() => setMenuOpen(true)}
				>
					☰
				</button>
				<NavLink to="/" className="brand">
					<span className="brand-mark" aria-hidden />
					StoreKeeper
				</NavLink>
			</header>
			<Sidebar open={menuOpen} onClose={() => setMenuOpen(false)} />
			{menuOpen && <div className="sidebar-scrim" aria-hidden onClick={() => setMenuOpen(false)} />}
			<main className="page">
				<Outlet />
			</main>
		</div>
	)
}
